import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: SPACES.xxxs,
  },
  statusIcon: {
    borderRadius: '50%',
    width: 10,
    height: 10,
  },

  selectionWrapper: {
    backgroundColor: theme.palette.custom.white,

    width: '100%',

    wordWrap: 'break-word',
    textDecoration: 'none',

    border: `1px solid ${theme.palette.custom.grey}`,

    [theme.breakpoints.down('tablet')]: {
      margin: `${SPACES.xxxs} 0`,

      padding: SPACES.xs,

      borderRadius: 10,
    },

    [theme.breakpoints.up('tablet')]: {
      margin: `${SPACES.xs} 0`,

      padding: `${SPACES.xxl} ${SPACES.xxl} ${SPACES.xl}`,

      borderRadius: 15,
    },
  },
  selectionContent: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.custom.white,
      justifyContent: 'space-between',
    },
  },
  switchWrapper: {
    marginTop: SPACES.xs,
  },

  bgAiGenerated: {
    '&&': {
      backgroundColor: theme.palette.custom.lightGreen,
    },
  },
}))
